// Helper.ts
export default {
  formatDate(
    date: Date,
    schedule: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'CUSTOM' = 'DAILY'
  ): string {
    const options = { year: 'numeric', month: 'long', day: 'numeric' } as const;

    if (schedule === 'DAILY') {
      return date.toLocaleDateString(undefined, options);
    }

    if (schedule === 'WEEKLY') {
      // Calculate start (Sunday) and end (Saturday) of the week
      const day = date.getDay(); // 0 (Sun) - 6 (Sat)
      const start = new Date(date);
      start.setDate(date.getDate() - day);
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);

      const startStr = start.toLocaleDateString(undefined, options);
      const endStr = end.toLocaleDateString(undefined, options);
      return `${startStr} - ${endStr}`;
    }

    if (schedule === 'MONTHLY') {
      // Format like "October 2025"
      return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
    }

    // Fallback format
    return date.toLocaleDateString();
  },
};
